// Localised WhatsApp welcome message for admins to send to registrants.
// The masterclass instant (fixed): 2026-09-17T18:00:00Z = 20:00 Europe/Madrid.
const MASTERCLASS_UTC_ISO = "2026-09-17T18:00:00Z";
const CHANNEL_URL = "https://whatsapp.com/channel/0029Vb7YjesIiRp1ZrnRuP1M";

// Single-zone country → IANA. Countries with multiple zones map to null so we
// fall back to "20:00 h de España" (never invent a wrong time).
const COUNTRY_TZ = {
  "españa": null, // sentinel: España base case
  "espana": null,
  "argentina": "America/Argentina/Buenos_Aires",
  "uruguay": "America/Montevideo",
  "chile": "America/Santiago",
  "venezuela": "America/Caracas",
  "colombia": "America/Bogota",
  "perú": "America/Lima",
  "peru": "America/Lima",
  "ecuador": "America/Guayaquil",
  "bolivia": "America/La_Paz",
  "paraguay": "America/Asuncion",
  "costa rica": "America/Costa_Rica",
  "panamá": "America/Panama",
  "panama": "America/Panama",
  "guatemala": "America/Guatemala",
  "honduras": "America/Tegucigalpa",
  "el salvador": "America/El_Salvador",
  "nicaragua": "America/Managua",
  "cuba": "America/Havana",
  "puerto rico": "America/Puerto_Rico",
  "rep. dominicana": "America/Santo_Domingo",
  "república dominicana": "America/Santo_Domingo",
  "portugal": "Europe/Lisbon",
  "francia": "Europe/Paris",
  "alemania": "Europe/Berlin",
  "reino unido": "Europe/London",
  "italia": "Europe/Rome",
  "andorra": "Europe/Andorra",
  "suiza": "Europe/Zurich",
  "países bajos": "Europe/Amsterdam",
  "paises bajos": "Europe/Amsterdam",
  "bélgica": "Europe/Brussels",
  "belgica": "Europe/Brussels",
  "irlanda": "Europe/Dublin",
  "austria": "Europe/Vienna",
  "dinamarca": "Europe/Copenhagen",
  "suecia": "Europe/Stockholm",
  "noruega": "Europe/Oslo",
  "finlandia": "Europe/Helsinki",
  "grecia": "Europe/Athens",
  "polonia": "Europe/Warsaw",
  "israel": "Asia/Jerusalem",
  "emiratos árabes": "Asia/Dubai",
  "emiratos arabes": "Asia/Dubai",
  "nueva zelanda": "Pacific/Auckland",
  "méxico": "America/Mexico_City",
  "mexico": "America/Mexico_City",
};
// Explicitly multi-zone → force fallback (never invent).
const MULTI_ZONE = new Set([
  "estados unidos", "eeuu", "usa",
  "brasil",
  "australia",
  "canadá", "canada",
  "indonesia",
]);

// Phone prefix → country display name (used as backup when country field is empty).
const PREFIX_TO_COUNTRY = {
  "+34": "España", "+52": "México", "+54": "Argentina",
  "+57": "Colombia", "+56": "Chile", "+51": "Perú", "+58": "Venezuela",
  "+593": "Ecuador", "+598": "Uruguay", "+595": "Paraguay", "+591": "Bolivia",
  "+506": "Costa Rica", "+507": "Panamá", "+502": "Guatemala", "+504": "Honduras",
  "+503": "El Salvador", "+505": "Nicaragua", "+53": "Cuba", "+351": "Portugal",
  "+33": "Francia", "+49": "Alemania", "+44": "Reino Unido", "+39": "Italia",
  "+376": "Andorra", "+41": "Suiza", "+31": "Países Bajos", "+32": "Bélgica",
  "+353": "Irlanda", "+43": "Austria", "+45": "Dinamarca", "+46": "Suecia",
  "+47": "Noruega", "+358": "Finlandia", "+30": "Grecia", "+48": "Polonia",
  "+972": "Israel", "+971": "Emiratos Árabes", "+64": "Nueva Zelanda",
};

function capitalizeFirstName(fullName) {
  if (!fullName) return "";
  const first = String(fullName).trim().split(/\s+/)[0] || "";
  if (!first) return "";
  return first.charAt(0).toUpperCase() + first.slice(1).toLowerCase();
}

function resolveCountry(reg) {
  const c = (reg.country || "").trim();
  if (c) return c;
  const pref = (reg.phone_country_code || "").trim();
  return PREFIX_TO_COUNTRY[pref] || "";
}

function hhmm(date, timeZone) {
  return new Intl.DateTimeFormat("es-ES", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
    timeZone,
  }).format(date);
}

/**
 * Returns the localised time snippet used inside the welcome message.
 * - Spain: "20:00 h de España"
 * - Single-zone country: "HH:MM hora de País (20:00 en España)"
 * - Multi-zone / unknown: "20:00 h de España" (safe fallback)
 */
export function timeSnippetForRegistrant(reg) {
  const country = resolveCountry(reg);
  const key = country.trim().toLowerCase();
  const madridStr = "20:00 h de España";

  if (!country || key === "españa" || key === "espana") return madridStr;
  if (MULTI_ZONE.has(key)) return madridStr;

  const tz = COUNTRY_TZ[key];
  if (!tz) return madridStr;

  try {
    const local = hhmm(new Date(MASTERCLASS_UTC_ISO), tz);
    return `${local} hora de ${country} (20:00 en España)`;
  } catch (_) {
    return madridStr;
  }
}

export function buildWelcomeMessage(reg) {
  const name = capitalizeFirstName(reg.first_name || reg.name || "");
  const hora = timeSnippetForRegistrant(reg);
  // Exact text — do not touch line breaks or accents.
  return (
`Hola ${name}, soy Santi.

He visto tu reserva para la masterclass del jueves 17, a las ${hora}. Has hecho bien: ese día vas a ver algo sobre ti que desde dentro no se suele ver.

Todo lo de la masterclass va por mi canal privado de WhatsApp. Ahí comparto reflexiones que no publico en ningún otro sitio, y el día antes dejo ahí el enlace de Zoom para entrar.

Este es el acceso: ${CHANNEL_URL}

¿Estás ya dentro del canal?`
  );
}

export function buildWhatsappUrl(reg) {
  const phoneDigits = (reg.phone || `${reg.phone_country_code || ""}${reg.phone_number || ""}`)
    .replace(/[^\d]/g, "");
  const text = buildWelcomeMessage(reg);
  return `https://wa.me/${phoneDigits}?text=${encodeURIComponent(text)}`;
}
